import * as types from '../../../../lib/actionTypes.es6'

const initialState = {
  groups: null,
  groups_loader: false,
  groups_error: null,

  current_group: null,
  current_group_loader: false,
  current_group_error: null,

  approve_group_loader: false,
  approve_group_success: false,
  approve_group_error: null,

  set_verification_loader: false,
  set_verification_success: false,
  set_verification_error: null,

  upload_document_loader: false,
  upload_document_success: false,
  upload_document_error: null,

  delete_document_loader: false,
  delete_document_success: false,
  delete_document_error: null,

  group_policies: null,
  group_policies_total: 0,
  // Echoed back from the request the rows came from, so the pagination control
  // reflects what is actually on screen rather than what was last clicked.
  group_policies_page: 1,
  group_policies_limit: 20,
  group_policies_loader: false,
  group_policies_error: null,

  // A bulk run reports progress as it goes: approve_policies_total is the run
  // size, approve_policies_results grows one entry per policy (successes and
  // failures alike), and approve_policies_success flips once the run closes.
  approve_policies_loader: false,
  approve_policies_success: false,
  approve_policies_error: null,
  approve_policies_total: 0,
  approve_policies_results: [],
  // 'reject' when the run is a rejection — drives the progress/summary wording.
  approve_policies_decision: null,

  // Policy issuance, kicked off automatically by approving the group.
  // issue_policies_state: null | 'issuing' | 'registered' | 'pending' | 'failed'
  issue_policies_state: null,
  issue_policies_queued: null,
  issue_policies_skipped: null,
  issue_policies_error: null
}

export default function omgGroupApprovalReducer(state, action) {
  if (state === undefined) {
    state = initialState
  }
  switch (action.type) {
    case types.GET_OMK_GROUPS_REQUEST:
      return Object.assign({}, state, {
        groups_loader: true,
        groups_error: null
      })
    case types.GET_OMK_GROUPS_SUCCESS:
      return Object.assign({}, state, {
        groups_loader: false,
        groups: action.payload,
        groups_error: null
      })
    case types.GET_OMK_GROUPS_FAILURE:
      return Object.assign({}, state, {
        groups_loader: false,
        groups_error: action.payload
      })

    case types.GET_OMK_GROUP_REQUEST:
      return Object.assign({}, state, {
        current_group_loader: true,
        current_group_error: null,
        current_group: null
      })
    case types.GET_OMK_GROUP_SUCCESS:
      return Object.assign({}, state, {
        current_group_loader: false,
        current_group: action.payload,
        current_group_error: null
      })
    case types.GET_OMK_GROUP_FAILURE:
      return Object.assign({}, state, {
        current_group_loader: false,
        current_group_error: action.payload
      })

    case types.APPROVE_OMK_GROUP_REQUEST:
      return Object.assign({}, state, {
        approve_group_loader: true,
        approve_group_success: false,
        approve_group_error: null
      })
    case types.APPROVE_OMK_GROUP_SUCCESS:
      return Object.assign({}, state, {
        approve_group_loader: false,
        approve_group_success: true,
        approve_group_error: null,
        current_group: action.payload
      })
    case types.APPROVE_OMK_GROUP_FAILURE:
      return Object.assign({}, state, {
        approve_group_loader: false,
        approve_group_error: action.payload
      })
    case types.APPROVE_OMK_GROUP_RESET:
      return Object.assign({}, state, {
        approve_group_loader: false,
        approve_group_success: false,
        approve_group_error: null
      })

    case types.SET_OMK_GROUP_VERIFICATION_REQUEST:
      return Object.assign({}, state, {
        set_verification_loader: true,
        set_verification_success: false,
        set_verification_error: null
      })
    case types.SET_OMK_GROUP_VERIFICATION_SUCCESS:
      return Object.assign({}, state, {
        set_verification_loader: false,
        set_verification_success: true,
        set_verification_error: null,
        current_group: action.payload
      })
    case types.SET_OMK_GROUP_VERIFICATION_FAILURE:
      return Object.assign({}, state, {
        set_verification_loader: false,
        set_verification_error: action.payload
      })
    case types.SET_OMK_GROUP_VERIFICATION_RESET:
      return Object.assign({}, state, {
        set_verification_loader: false,
        set_verification_success: false,
        set_verification_error: null
      })

    // Both document mutations answer with the whole updated group, so the
    // success case refreshes current_group straight from the payload.
    case types.UPLOAD_OMK_GROUP_DOCUMENT_REQUEST:
      return Object.assign({}, state, {
        upload_document_loader: true,
        upload_document_success: false,
        upload_document_error: null
      })
    case types.UPLOAD_OMK_GROUP_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        upload_document_loader: false,
        upload_document_success: true,
        upload_document_error: null,
        current_group: action.payload
      })
    case types.UPLOAD_OMK_GROUP_DOCUMENT_FAILURE:
      return Object.assign({}, state, {
        upload_document_loader: false,
        upload_document_error: action.payload
      })
    case types.UPLOAD_OMK_GROUP_DOCUMENT_RESET:
      return Object.assign({}, state, {
        upload_document_loader: false,
        upload_document_success: false,
        upload_document_error: null
      })

    case types.DELETE_OMK_GROUP_DOCUMENT_REQUEST:
      return Object.assign({}, state, {
        delete_document_loader: true,
        delete_document_success: false,
        delete_document_error: null
      })
    case types.DELETE_OMK_GROUP_DOCUMENT_SUCCESS:
      return Object.assign({}, state, {
        delete_document_loader: false,
        delete_document_success: true,
        delete_document_error: null,
        current_group: action.payload
      })
    case types.DELETE_OMK_GROUP_DOCUMENT_FAILURE:
      return Object.assign({}, state, {
        delete_document_loader: false,
        delete_document_error: action.payload
      })
    case types.DELETE_OMK_GROUP_DOCUMENT_RESET:
      return Object.assign({}, state, {
        delete_document_loader: false,
        delete_document_success: false,
        delete_document_error: null
      })

    case types.GET_OMK_GROUP_POLICIES_REQUEST:
      return Object.assign({}, state, {
        group_policies_loader: true,
        group_policies_error: null
      })
    case types.GET_OMK_GROUP_POLICIES_SUCCESS:
      return Object.assign({}, state, {
        group_policies_loader: false,
        group_policies: action.payload.policies,
        group_policies_total: action.payload.total,
        group_policies_page: action.payload.page || 1,
        group_policies_limit:
          action.payload.limit || state.group_policies_limit,
        group_policies_error: null
      })
    case types.GET_OMK_GROUP_POLICIES_FAILURE:
      return Object.assign({}, state, {
        group_policies_loader: false,
        group_policies_error: action.payload
      })

    case types.APPROVE_OMK_GROUP_POLICIES_REQUEST:
      return Object.assign({}, state, {
        approve_policies_loader: true,
        approve_policies_success: false,
        approve_policies_error: null,
        approve_policies_results: [],
        approve_policies_total: 0,
        approve_policies_decision: action.payload
          ? action.payload.decision
          : null
      })
    case types.APPROVE_OMK_GROUP_POLICIES_STARTED:
      return Object.assign({}, state, {
        approve_policies_total: action.payload
      })
    case types.APPROVE_OMK_GROUP_POLICY_RESULT:
      return Object.assign({}, state, {
        approve_policies_results: state.approve_policies_results.concat([
          action.payload
        ])
      })
    case types.APPROVE_OMK_GROUP_POLICIES_SUCCESS:
      return Object.assign({}, state, {
        approve_policies_loader: false,
        approve_policies_success: true,
        approve_policies_error: null
      })
    case types.APPROVE_OMK_GROUP_POLICIES_FAILURE:
      return Object.assign({}, state, {
        approve_policies_loader: false,
        approve_policies_error: action.payload
      })
    case types.APPROVE_OMK_GROUP_POLICIES_RESET:
      return Object.assign({}, state, {
        approve_policies_loader: false,
        approve_policies_success: false,
        approve_policies_error: null,
        approve_policies_results: [],
        approve_policies_total: 0
      })

    case types.ISSUE_OMK_GROUP_POLICIES_STARTED:
      return Object.assign({}, state, {
        issue_policies_state: 'issuing',
        issue_policies_queued: null,
        issue_policies_skipped: null,
        issue_policies_error: null
      })
    case types.ISSUE_OMK_GROUP_POLICIES_QUEUED:
      return Object.assign({}, state, {
        issue_policies_queued: action.payload.queued,
        issue_policies_skipped: action.payload.skipped
      })
    case types.ISSUE_OMK_GROUP_POLICIES_REGISTERED:
      return Object.assign({}, state, {
        issue_policies_state: 'registered'
      })
    // Still running when we stopped waiting — not a failure.
    case types.ISSUE_OMK_GROUP_POLICIES_PENDING:
      return Object.assign({}, state, {
        issue_policies_state: 'pending'
      })
    case types.ISSUE_OMK_GROUP_POLICIES_FAILURE:
      return Object.assign({}, state, {
        issue_policies_state: 'failed',
        issue_policies_error: action.payload
      })

    default:
      return state
  }
}
